<mbs-modal [title]="'shared:modals.immutability.immutabilityDisableTitle' | i18next">
  <ng-container modal-body>
    <div
      class="mb-3"
      [innerHTML]="'shared:modals.immutability.immutabilityDisableTextPartOne' | i18next"></div>
    <div
      class="mb-3"
      [innerHTML]="'shared:modals.immutability.immutabilityDisableTextPartTwo' | i18next"></div>

    <mbs-checkbox
      [label]="'shared:modals.immutability.disablingConfirmation' | i18next"
      [(ngModel)]="confirmed"></mbs-checkbox>
  </ng-container>
  <ng-container modalFooter>
    <mbs-button
      type="danger"
      [disabled]="!confirmed"
      (click)="confirmClickHandler()"
      >{{ 'shared:buttons.disable' | i18next: { format: 'title' } }}</mbs-button
    >
    <mbs-button
      type="secondary"
      (click)="cancelClickHandler()"
      >{{ 'shared:buttons.cancel' | i18next: { format: 'title' } }}</mbs-button
    >
  </ng-container>
</mbs-modal>
